<template>
  <div class="success-edit-info">
    <svgicon name="Controls/Check" />
    {{ successInfoText }}
  </div>
</template>

<script>
export default {
  name: 'SuccessEditInfo',
  props: {
    successInfoText: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.success-edit-info {
  background-color: $color-green-special;
  color: $color-green-mid;
  padding: 0.75rem;
  border-radius: 3px;
  margin: 1rem 0;
  display: flex;
  align-items: flex-start;

  @include font(text, 3, "normal");

  &--nomarginbottom {
    margin-bottom: 0;
  }

  svg {
    fill: $color-green-mid;
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem;
  }
}
</style>
